/**
 * @generated SignedSource<<f782d73e380335e70ba75a2305d23155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdatePurchaseOrderReferenceInput = {
  purchaseOrderReference: string;
  subscriptionIdentifier: string;
};
export type SubscriptionViewUpdatePurchaseOrderReferenceMutation$variables = {
  input: UpdatePurchaseOrderReferenceInput;
};
export type SubscriptionViewUpdatePurchaseOrderReferenceMutation$data = {
  readonly updatePurchaseOrderReference: {
    readonly id: string;
    readonly purchaseOrderReference: string | null | undefined;
  };
};
export type SubscriptionViewUpdatePurchaseOrderReferenceMutation = {
  response: SubscriptionViewUpdatePurchaseOrderReferenceMutation$data;
  variables: SubscriptionViewUpdatePurchaseOrderReferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "updatePurchaseOrderReference",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "purchaseOrderReference",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionViewUpdatePurchaseOrderReferenceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionViewUpdatePurchaseOrderReferenceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8571ac099dd37ce9cf5f9679b383fe47",
    "id": null,
    "metadata": {},
    "name": "SubscriptionViewUpdatePurchaseOrderReferenceMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionViewUpdatePurchaseOrderReferenceMutation(\n  $input: UpdatePurchaseOrderReferenceInput!\n) {\n  updatePurchaseOrderReference(input: $input) {\n    id\n    purchaseOrderReference\n  }\n}\n"
  }
};
})();

(node as any).hash = "53874c119344dd2785867e2ad2d8c4cf";

export default node;
